import { selectPictureUriById } from 'affiny-core/redux/selectors/picturesSelectors';
import { connect } from 'react-redux';
import { IRootState } from '../../state';
import { IPictureFormat } from '../types';

export interface IPictureContainerOwnProps {
  pictureId: string | undefined;
  format?: IPictureFormat;
  isBlurredFormat?: boolean;
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IPictureContainerOwnProps
) => ({
  pictureUri:
    ownProps.pictureId &&
    selectPictureUriById(
      state,
      ownProps.pictureId,
      ownProps.format,
      ownProps.isBlurredFormat
    ),
});

export interface IPictureContainerProps {
  pictureUri?: string;
}

export const pictureContainerFactory = connect(mapStateToProps);
